import styled from 'styled-components';
import { DisplayBox } from '@m/alchemy-ui/DisplayBox';
import { Tabs as AlchemyTabs } from '@m/alchemy-ui/Tabs';
import { color, units, typeStyle } from '@m/alchemy-ui/theme';

import { SettingsRewardsSubtitle } from 'settings/containers/SettingsRewards/SettingsRewardsSubtitle';

export const Container = styled(DisplayBox).attrs({
  depth: 'moduleChrome',
  hoverDepth: 'moduleChrome',
})`
  ${typeStyle('bodyS')};
  border: none;
  color: ${color('base', { palette: 'interactiveNavigational' })};
  padding: ${units(3)};

  & strong {
    font-weight: 700;
  }
`;

export const Tabs = styled(AlchemyTabs)`
  margin-bottom: ${units(3)}
`;

export const TabItem = styled.span`
  ${typeStyle('headerS')};
`;

export const EmptyText = styled(SettingsRewardsSubtitle)`
  color: ${color('contrast', { palette: 'illustrativeSteelGrey' })};
  margin: ${units(8)} auto;

  &:last-child {
    margin-bottom: ${units(8)};
  }
`;
